@if (loaded) {
<section class="oem-link-section">
  <h3>OEM machine linkage</h3>
  <p class="muted small">
    Link OEM machines to your harvesters. Linkages are shared with the
    per-provider Integrations page — changes made here appear there, and vice
    versa.
  </p>

  @for (row of rows; track row.provider) { @if (row.active) {
  <app-machine-link-panel
    [provider]="row.provider"
    [providerLabel]="row.label"
    [grantsGated]="row.provider === Provider.Deere"
    [status]="row.status"
    [preselectHarvesterId]="preselectHarvesterId"
  ></app-machine-link-panel>
  } @else {
  <p class="muted small connect-hint">
    {{ row.label }}: no active connection &mdash; connect the vendor on the
    <a routerLink="/integrations">Integrations page</a> first to link its
    machines.
  </p>
  } }
</section>
}
